import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, BasicApiResponseModel, ApiVisa, ApiResponseModel} from '../../shared';
import { Observable } from 'rxjs';
import { StockAvailabilityOutputDtoModel } from '../../../../../../models/aggregates/erp/stock/stock-availability-output-dto.model';
import { BinAvailabilityContainer } from '../../../../../../models/aggregates/erp/stock/bin-availability-container.model';
import { BinAvailabilityQueryCriteria } from '../../../../../../models/aggregates/erp/stock/bin-availability-query-criteria.model';
import { StockBinAvailabilityContainer } from '../../../../../../models/aggregates/erp/stock/stock-bin-availability-container.model';
export interface StockAvailabilityInputModel {
  inventory_item_guids: [];
  location_guids: [];
  stock_server_doc_type_signum_dto_list: string;
  keyword: string;
}

export interface BinAvailabilityOutputModel {
  stockAvailabilityDetailsOutputDto: StockAvailabilityOutputDtoModel;
  binAvailabilityContainers: BinAvailabilityContainer[];
}
@Injectable({
  providedIn: 'root'
})
export class StockAvailabilityService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'stock-availability';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'stock-availability';
    this.httpClient = http;
  }

  public getAPIUrl(apiVisa: ApiVisa) {
    let url = this.apiUrl;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + this.endpoint_path;
    }
    return url;
  }

  public getStockAvailability(inputModel: StockAvailabilityInputModel, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.getAPIUrl(apiVisa);
    let formData = {
    
    };
    if (inputModel) formData = inputModel;

    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      formData,
      this.getHttpHeader(apiVisa)
    );
  }

  public getStockBalanceByCriteria(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/opening-stock-balance/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getStockAvailabilityWithBins(inputModel: StockAvailabilityInputModel, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.getAPIUrl(apiVisa);
    let formData = {};
    if (inputModel) formData = inputModel;

    url += "/with-bins/backoffice-ep"
    return this.httpClient.post<ApiResponseModel<BinAvailabilityOutputModel>>(
      url,
      formData,
      this.getHttpHeader(apiVisa)
    );
  }

  public getStockAvailabilityWithBinsV2(criteria: BinAvailabilityQueryCriteria, apiVisa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url = this.getAPIUrl(apiVisa);
    url += "/with-bins/v2/backoffice-ep"
    return this.httpClient.post<ApiResponseModel<StockBinAvailabilityContainer>>(
      url,
      criteria,
      this.getHttpHeader(apiVisa)
    );
  }

}
